import api from './../plugins/httpRequest'
import { availableRouteNames } from './../plugins/router'

const apiLogin = (params)=>{
    return api.post("api/login",params)
}

const getMenu = (params)=>{
    return api.get("api/menus",{params})
}

const updateItem = (params)=>{
    return params.reduce(function (items, item){
        const next = { ...item };
        next.icon = next.icon ? next.icon.split("-").pop() : '';
        if (next.children){
            next.children = updateItem(next.children);
            if (!next.children.length) {
                delete next.children;
            }
        }
        if (next.path && !availableRouteNames.has(next.path) && !next.children) {
            return items;
        }
        if (!next.path && !next.children) {
            return items;
        }
        items.push(next);
        return items;
    }, [])
}

export default {
    namespaced: true,
    state: {
        loading:false
    },
    mutations: {
        // 注意，这里可以设置 state 属性，但是不能异步调用，异步操作写到 actions 中
        LOGIN(state, user) {
            sessionStorage.setItem("user", JSON.stringify(user));
            state.loading = false;
        },
        LIST(state, data) {
            state.loading = false
            state.menu = updateItem(data);
        }
    },
    actions: {
        login({commit,state},params) {
            state.loading = true;
            apiLogin(params).then(function(res) {
                commit('LOGIN', res.data);
            },function() {
                state.loading = false;
            });
        },
        getMenu({commit,state},params) {
            state.loading = true;
            getMenu(params).then(function(res) {
                commit('LIST', res.data);
            },function() {
                state.loading = false;
            });
        },
    }
}
